<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="settingsObj" ref="settingsReference">
      <template slot="extraDetails">
        <v-layout wrap class="pa-0 pt-3 pl-3 pr-3 pb-2 wrap">
          <v-flex xs12 sm6 lg4 class="pl-2">
            <v-flex xs12>
              <h4>{{ $t('message.invoice.invoiceBody') }}:</h4>
            </v-flex>
            <v-flex xs12>
              <ckeditor :editor="editor" v-model="settingsObj.mail_body" :config="editorConfig"></ckeditor>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm6 lg4 class="pl-2">
            <v-flex xs12>
              <h4>{{ $t('message.invoice.creditBody') }}:</h4>
            </v-flex>
            <v-flex xs12>
              <ckeditor :editor="editor" v-model="settingsObj.creditnote_mail_body" :config="editorConfig"></ckeditor>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm6 lg4 class="pl-2">
            <v-flex xs12>
              <h4>{{ $t('message.invoice.signature') }}:</h4>
            </v-flex>
            <v-flex xs12>
              <ckeditor :editor="editor" v-model="settingsObj.mail_signature" :config="editorConfig"></ckeditor>
            </v-flex>
          </v-flex>
        </v-layout>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      settingsObj: {},
      fieldsLoading: false,
      loading: false,
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      }
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.$t('message.invoice.invoiceEmail'),
        properties: [{
          model: 'from_email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.user.email'),
          class: 'lg4 sm6'
        }, {
          model: 'mail_subject',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.invoice.subject'),
          class: 'lg4 sm6'
        }, {
          model: '',
          type: null,
          rules: [],
          label: '',
          class: 'xs12 pa-0'
        }, {
          model: '',
          type: null,
          rules: [],
          label: '',
          class: 'xs12 pa-0'
        }, {
          model: 'nordeaemail',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: `Nordea ${this.$t('message.customer.email')}`,
          class: 'lg4 sm6'
        }, {
          model: 'xledgeremail',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: `xLedger ${this.$t('message.customer.email')}`,
          class: 'lg4 sm6'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    this.getSingleRecordHandler()
  },
  methods: {
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.settingsReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.settingsObj
        this.$_executeApi('post', 'invoicesettings', model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
            this.getSingleRecordHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  }
}
</script>
